import axiosInstance from '../../config/axios.config';

const BASE = '/superadmin/borrower-reports';

const superAdminBorrowerReportService = {
    /**
     * List all borrower reports across tenants with filters and pagination.
     */
    async getReports(params = {}) {
        try {
            const response = await axiosInstance.get(BASE, { params });
            return response.data;
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || 'Failed to fetch reports', data: [], meta: {} };
        }
    },

    /**
     * Get a single report by ID (includes full report_json).
     */
    async getReport(id) {
        try {
            const response = await axiosInstance.get(`${BASE}/${id}`);
            return response.data;
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || 'Failed to fetch report' };
        }
    },

    /**
     * Aggregate statistics across all tenants.
     */
    async getStatistics() {
        try {
            const response = await axiosInstance.get(`${BASE}/statistics`);
            return response.data;
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || 'Failed to fetch statistics' };
        }
    },

    /**
     * Get distinct tenants that have borrower reports (for filter dropdown).
     */
    async getTenants() {
        try {
            const response = await axiosInstance.get(`${BASE}/tenants`);
            return response.data;
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || 'Failed to fetch tenants' };
        }
    },
};

export default superAdminBorrowerReportService;
